import { Navigate, Outlet } from 'react-router-dom';
import { isAdminLoggedIn } from '@/hooks/useAdminAuth';

export default function AdminProtectedRoute() {
  if (!isAdminLoggedIn()) {
    return <Navigate to="/admin/login" replace />;
  }
  return <Outlet />;
}
